module.exports = __webpack_public_path__ + "static/media/python.a1c11146.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/python.png
// module id = 104
// module chunks = 0